import type { PropsWithChildren } from 'react';
import { Typography } from '@mui/material';
import { Container } from './error-page.styled';

interface ErrorPageProps extends PropsWithChildren {
    title: string;
    message: string;
    isLayout?: boolean;
    fullHeight?: boolean;
    size?: 'small' | 'large';
}

const ErrorPage = ({
    title,
    message,
    children,
    isLayout = true,
    size = 'large',
    fullHeight = true,
}: ErrorPageProps) => {
    const titleVariant = size === 'small' ? 'h4' : 'h1';
    const messageVariant = size === 'small' ? 'h6' : 'h2';

    return (
        <Container $isLayout={isLayout} $fullHeight={fullHeight}>
            <Typography variant={titleVariant} component='div' gutterBottom align='center'>
                {title}
            </Typography>
            <Typography variant={messageVariant} component='div' gutterBottom align='center'>
                {message}
            </Typography>
            {children}
        </Container>
    );
};

export { ErrorPage };
